import { UserApi } from "../Constants/api";
import axiosInstance from "../Utils/axiosInstance";

export const getUsersApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${UserApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
